/* Great Lakes Lavender Farm — homepage scroll reveal (respects reduced motion; content stays visible without JS). */
(function(){
  if(window.__gllfAward)return;window.__gllfAward=1;
  if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var secs=[].slice.call(document.querySelectorAll('.gllf-home-editor-section'));if(!secs.length)return;
  document.documentElement.classList.add('aw-ready');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('aw-in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  secs.forEach(function(s){var r=s.getBoundingClientRect();if(r.top<innerHeight)s.classList.add('aw-in');else io.observe(s)});
  setTimeout(function(){secs.forEach(function(s){s.classList.add('aw-in')})},6000);
})();
